<template>
<div id="facilities">
    <v-row>
        <v-col md="10" cols="12">
            <v-row>
                <v-col cols="12" md="6" class="pt-2">
                    <v-text-field class="ma-0 pa-0" v-model="search" clearable :placeholder="$t('hotel.facilities.search_placeholder')" append-icon="search"></v-text-field>
                </v-col>
            </v-row>

            <div v-scroll-spy="{offset: 50}">
                <div class="">
                    <div class="important pl-2 pt-2" id="activities">{{ $t('hotel.facilities.activities') }}</div>
                    <v-row>
                        <v-col md="3" sm="6" cols="12" v-for="item in filterActivities()" :key="item.id" class="py-0">
                            <v-checkbox class="im-check-box ma-0 pa-0" v-model="activities_ids" :label="$t('hotel-activities.'+ item.slug)" :value="item.id" color="primary" @change="selectedActivity(item.id)" />
                        </v-col>
                    </v-row>
                    <div class="important pl-2 pt-2">{{ $t('hotel.facilities.facilities') }}</div>
                </div>
                <div class="" v-for="(category,index) in unique_categories" :key="index">
                    <div v-if="filterCategories(category).length > 0" column class="pl-2">
                        <div class="subheading pl-2 py-2" style="text-transform: capitalize;" :id="category">{{ $t('hotel.facilities.category.' + category) }}</div>
                        <v-row>
                            <template v-for="(item_category,item_index) in filterCategories(category)">
                                <v-col md="3" sm="6" cols="12" class="py-0" :key="item_category.id">
                                    <v-checkbox class="im-check-box ma-0 pa-0" v-model="facilities_ids" :label="$t('hotel-facilities.'+ item_category.slug)" :value="item_category.id" color="primary" @change="selectedFacility(item_category.id)" />
                                </v-col>
                            </template>
                        </v-row>
                    </div>
                </div>
            </div>
        </v-col>
        <v-col v-if="!search" md="2" :class="{'d-none': $vuetify.breakpoint.smAndDown}" id="menu-hotel-facilities">
            <div class="menu-fixed">
                <ul v-scroll-spy-active="{selector: 'li.menu-item', class: 'custom-active'}" v-scroll-spy-link>
                    <li v-for="(item_menu,index) in menu_items" class="menu-item pa-2" :key="index">
                        <a class="important text-capitalize">{{ $t('hotel.facilities.category.' + item_menu) }}</a>
                    </li>
                </ul>

            </div>

        </v-col>
    </v-row>

</div>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        item: Object,
        config: Object,
        active: Object,
    },
    name: `hotel-facilities`,

    data() {
        return {
            menu_fixed: false,
            target: null,
            dialog_price_faciliy: false,
            unit_price_facilities: [
                {
                    text: "Noapte",
                    value: "night"
                }, {
                    text: "Persoana",
                    value: "person"
                }, {
                    text: "Ora",
                    value: "hour"
                }, {
                    text: "Sejur",
                    value: "stay"
                }, {
                    text: "Bucata",
                    value: "piece"
                }
            ],

            // input input items
            facility: {
                id: null,
                pricing: {
                    free: true,
                    unit: null,
                    value: null
                }
            },
            activities_ids: [],
            facilities_ids: [],
            selected_activities: [],
            selected_categories: [],
            selected_facilities: [],
            facilities_categories: [],
            search: null,
            select: null,

        };
    },

    computed: {

        unique_categories: {
            get: function () {
                if(this.config.facilities) {
                    let facilities = this.config.facilities;
                    return [...new Set(facilities.map(item => item.category))];
                } else {
                    return null
                }
            }
        },

        menu_items: {
            get: function () {
                if(this.config.facilities) {
                    let items = ['activities']
                    let facilities = this.config.facilities;
                    let unique_facilities = [...new Set(facilities.map(item => item.category))]
                    return items.concat(unique_facilities);
                } else {
                    return null
                }
            }
        },

    },

    mounted() {
        // prepare models  for activities and facilities selection
        let f_ids = [];
        if(Array.isArray(this.item.static.facilities)) {
            this.item.static.facilities.forEach(function (item) {
                if(item !== null) {
                    this.facilities_ids.push(Number(item.id))
                }
            }.bind(this))
        } else {
            f_ids = Object.keys(this.item.static.facilities);
            f_ids.forEach(function (item) {
                if(this.item.static.facilities[item] !== null && this.item.static.facilities[item].id == item) {
                    this.facilities_ids.push(Number(item))
                }

            }.bind(this))
        }

        let a_ids = [];
        if(Array.isArray(this.item.static.activities)) {
            this.item.static.activities.forEach(function (item) {
                if(item !== null) {
                    this.activities_ids.push(Number(item.id))
                }
            }.bind(this))
        } else {
            a_ids = Object.keys(this.item.static.activities);
            a_ids.forEach(function (item) {
                if(this.item.static.activities[item] !== null && this.item.static.activities[item].id == item) {
                    this.activities_ids.push(Number(item))
                }

            }.bind(this))
        }

    },
    watch: {
        item: {
            handler: function (value) {
                this.facilities_ids = [];
                let f_ids = [];
                if(Array.isArray(this.item.static.facilities)) {
                    this.item.static.facilities.forEach(function (item) {
                        if(item !== null) {
                            this.facilities_ids.push(Number(item.id))
                        }
                    }.bind(this))
                } else {
                    f_ids = Object.keys(this.item.static.facilities);
                    f_ids.forEach(function (item) {
                        if(this.item.static.facilities[item] !== null && this.item.static.facilities[item].id == item) {
                            this.facilities_ids.push(Number(item))
                        }
                    }.bind(this))
                }

                let a_ids = [];
                this.activities_ids = [];
                if(Array.isArray(this.item.static.activities)) {
                    this.item.static.activities.forEach(function (item) {
                        if(item !== null) {
                            this.activities_ids.push(Number(item.id))
                        }
                    }.bind(this))
                } else {
                    a_ids = Object.keys(this.item.static.activities);
                    a_ids.forEach(function (item) {
                        if(this.item.static.activities[item] !== null && this.item.static.activities[item].id == item) {
                            this.activities_ids.push(Number(item))
                        }
                    }.bind(this))
                }
            },
            deep: true
        },

    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        filterCategories(filter) {

            let locale_facilities = this.$i18n.messages[this.$i18n.locale]['hotel-facilities'];
            let keys = Object.keys(locale_facilities)
                .filter(function (key) {
                    if(locale_facilities[key].toLowerCase()
                        .includes(this.search || '')) {
                        return key
                    }
                }.bind(this));

            let items = this.config.facilities.filter(e => {
                return keys.includes(e.slug) && e.category === filter
            })

            return items;
        },

        filterActivities() {
            let locale_facilities = this.$i18n.messages[this.$i18n.locale]['hotel-activities'];
            let keys = Object.keys(locale_facilities)
                .filter(function (key) {
                    if(locale_facilities[key].toLowerCase()
                        .includes(this.search || '')) {
                        return key
                    }
                }.bind(this));

            let items = this.config.activities.filter(e => {
                return keys.includes(e.slug)
            })
            return items
        },

        selectedActivity(value) {
            if(this.activities_ids.includes(value)) {
                this.$set(this.item.static.activities, value, {
                    'id': value,
                    'price': null
                })
            } else {
                this.$set(this.item.static.activities, value, null)
            }
        },

        priceFacilicty(value) {
            this.facility = this.selected_facilities[value];
            this.dialog_price_faciliy = true;
        },

        selectedFacility(value) {
            if(this.facilities_ids.includes(value)) {
                this.$set(this.item.static.facilities, value, {
                    'id': value,
                    'price': null
                })

            } else {
                this.$set(this.item.static.facilities, value, null)
            }
        },

        updateFacility(item) {
            let data = item.id;
            this.selected_categories[data] = item;
            this.dialog_price_faciliy = false;
        },


    },

};
</script>
<style lang="stylus">
#menu-hotel-facilities
    .menu-fixed
        position: sticky
        top: 90px
        ul
            height: 24px
            line-height: 24px
            list-style-type: none
        .custom-active
            padding-left: 10px
            border-left: 2px solid blue
</style>
